import React, { useState, useEffect } from "react";
import Textinput from "@/components/ui/Textinput";
import { CiSearch } from "react-icons/ci";

const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  
  // Sync local state with prop when filter prop changes
  useEffect(() => {
    setValue(filter);
  }, [filter]);
  
  const onChange = (e) => {
    const newValue = e.target.value;
    console.log('🔍 [GlobalFilter] Input changed to:', newValue);
    setValue(newValue);
    // Don't send undefined, send empty string or the value
    setFilter(newValue);
  };
  
  return (
    <div>
      <Textinput
        value={value || ""}
        onChange={onChange}
        placeholder="search..."
        className="rounded-md border-black-400 w-[15vw] relative"
      >
        <CiSearch className="absolute z-10" />
      </Textinput>
    </div>
  );
};

export default GlobalFilter;
